export function resolveHookState(nextState, previousState) {
    if (typeof nextState === 'function')
        return nextState(previousState);
    return nextState;
}
